module.exports = __webpack_public_path__ + "static/img/12.aad537f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/12.png
// module id = SVKk
// module chunks = 1